import React from "react"
import StrapiMedia from "../strapi-media"

import "../../styles/main.less"

const MainBanner = ({ data }) => {
  if (!data) return <div></div>

  const { title, image, html } = data?.attributes ?? {}

  return (
    <div className="max-w-screen-xl w-full mx-auto mt-8 sm:mt-24 lg:flex items-center justify-between px-7 2xl:px-0">
      <div className="sm:w-3/4 lg:w-5/12">
        <h1 className="font-cardo sm:font-cardo--46 sm:font-cardo--53 xl:font-cardo--70 leading-tight lg:leading-none mb-5 sm:ml-20 lg:ml-0 pr-10">
          {title}
        </h1>
        {html && <div dangerouslySetInnerHTML={{ __html: html }} />}
      </div>
      <StrapiMedia image={image} className="w-full lg:w-7/12" />
    </div>
  )
}

export default MainBanner
